import React from "react";

// Reusable page intro / hero for inner pages
const PageHero = ({ eyebrow, title, subtitle, children }) => {
  return (
    <section
      className="border-b border-[#E0E0E0] aevos-grid-bg"
      data-testid="page-hero"
    >
      <div className="aevos-container py-16 md:py-24">
        {eyebrow && (
          <div className="aevos-eyebrow mb-4 fade-up">{eyebrow}</div>
        )}
        <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-black max-w-4xl fade-up delay-1 leading-[1.05]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-[#333333] max-w-2xl text-base md:text-lg fade-up delay-2">
            {subtitle}
          </p>
        )}
        {children && <div className="mt-8 fade-up delay-3">{children}</div>}
      </div>
    </section>
  );
};

export default PageHero;
